import { useMelwaysLink } from '@seek/melways-react';
import type { Country, Language } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import {
  Box,
  ButtonLink,
  Column,
  Columns,
  ContentBlock,
  Heading,
  Stack,
  Text,
} from 'braid-design-system';
import type React from 'react';

import translations from './.vocab';

interface PriceCheckerProps {
  country: Country;
  language: string;
  onClick: (eventName: string) => void;
}

export const PriceCheckerPanel: React.FC<
  React.PropsWithChildren<PriceCheckerProps>
> = ({ language, onClick }) => {
  const { t } = useTranslations(translations);
  const localize = useMelwaysLink();

  return (
    <ContentBlock>
      <Box
        boxShadow="borderNeutralLight"
        borderRadius="xlarge"
        background="surface"
        padding="gutter"
      >
        <Stack space="gutter">
          <Heading
            level="3"
            align={{
              mobile: 'center',
              tablet: 'center',
              desktop: 'left',
            }}
          >
            {t('not sure which ad budget you need?')}
          </Heading>
          <Columns collapseBelow="desktop" space="gutter">
            <Column>
              <Stack space="small">
                <Text component="p">
                  {t(
                    'estimate how much you need by checking the full price...',
                  )}
                </Text>
                <Text component="p">
                  {t('job ads on SEEK are variably priced...')}
                </Text>
                <Text component="p">
                  {t('check your ad price to give you an idea...')}
                </Text>
              </Stack>
            </Column>
            <Column width="content">
              <ButtonLink
                variant="ghost"
                role="PriceCheckerLink"
                href={localize({
                  path: '/account/ad-price-lookup/preview',
                  language: language as Language,
                })}
                target="_blank"
                onClick={() =>
                  onClick('seek_contract_lookup_exact_ad_prices_pressed')
                }
              >
                {t('check ad price')}
              </ButtonLink>
            </Column>
          </Columns>
        </Stack>
      </Box>
    </ContentBlock>
  );
};
